import { useState, useEffect } from 'react';

function computeScale(width) {
  if (width >= 2560) return 1.9;
  if (width >= 1920) return 1.5;
  if (width >= 1600) return 1.25;
  if (width >= 1440) return 1.15;
  return 1.0; // laptop / small desktop
}

export function useHeaderScale() {
  const [scale, setScale] = useState(() => computeScale(window.innerWidth));

  useEffect(() => {
    const handler = () => setScale(computeScale(window.innerWidth));
    window.addEventListener('resize', handler);
    return () => window.removeEventListener('resize', handler);
  }, []);

  return scale;
}